import { ApplicationEditIcon } from './ApplicationEditIcon';

/**
 * author: Michael Irigoyen
 * id AAF23976-7C9D-4AFA-BE25-CCD225A95EEA
 * name application-edit
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-edit.svg
 * tags
 * - Edit / Modify 
 */
export const IframeEditIcon = ApplicationEditIcon;
export default IframeEditIcon